import apiHandler from "../core/apiHandler";

const productUnitApi = apiHandler('product-units');
export default productUnitApi;